import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PresetsPage } from "@/features/presets/PresetsPage";

const search = z.object({
  type: z.string().optional(),
  q: z.string().optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/presets/")({
  validateSearch: search,
  component: () => <PresetsPage search={Route.useSearch()} />,
});
